import { render, staticRenderFns } from "./ContentRenderer.vue?vue&type=template&id=5ed762bf&scoped=true&"
import script from "./ContentRenderer.vue?vue&type=script&lang=js&"
export * from "./ContentRenderer.vue?vue&type=script&lang=js&"
import style0 from "./ContentRenderer.vue?vue&type=style&index=0&id=5ed762bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed762bf",
  null
  
)

export default component.exports